module.exports = __webpack_public_path__ + "media/images/copy-5616669e1ebfdbb01a55ac51c03d4d77.svg";